import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: 'Do you offer custom tailoring near me?',
    a: 'Very likely yes. Custom Clothiers serves all of Massachusetts and New England. Our master tailors make house and office call appointments throughout the region, so no matter where you are in Massachusetts — Boston, Newton, Cambridge, Worcester, Cape Cod, or beyond — we can come to you. Call us at 781-237-3166 to confirm service in your specific area.',
  },
  {
    q: 'Which areas do you serve?',
    a: 'We are based in Wellesley, MA and serve the entire state of Massachusetts, including Greater Boston, MetroWest, the North Shore, South Shore, Worcester County, and the Cape. We also serve clients throughout New England. Our showroom is open Monday–Friday 8AM–5PM and our tailors travel statewide for home and office appointments.',
  },
  {
    q: 'Can a tailor come to my home in Massachusetts?',
    a: 'Absolutely. Our house and office call service is one of our most popular offerings. A master tailor will come to your home or workplace with fabric samples, take your measurements, and provide a full consultation experience — at no additional travel cost for most Massachusetts locations. Call us to schedule.',
  },
  {
    q: 'Is your Wellesley showroom open on weekends?',
    a: 'Yes. Our Wellesley showroom at 326A Washington Street is open Saturday from 8:00 AM to 4:00 PM, in addition to Monday through Friday from 8:00 AM to 5:00 PM. We recommend calling ahead to ensure a tailor is available for your specific service.',
  },
];

const LocationsFAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <>
      {/* Map Section */}
      <section className="py-24 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-3">Visit Our Wellesley Showroom</h2>
            <p className="text-gray-400 text-lg">326A Washington St, Wellesley, MA 02481</p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch">
            {/* Info Panel */}
            <div className="space-y-5">
              <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#C4A962]/20 rounded-xl">
                    <i className="ri-map-pin-line text-[#C4A962] text-xl"></i>
                  </div>
                  <h3 className="font-bold text-white">Address</h3>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed">326A Washington Street<br />Wellesley, MA 02481</p>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#C4A962]/20 rounded-xl">
                    <i className="ri-time-line text-[#C4A962] text-xl"></i>
                  </div>
                  <h3 className="font-bold text-white">Hours</h3>
                </div>
                <div className="text-gray-400 text-sm space-y-1">
                  <p>Monday – Friday: 8:00 AM – 5:00 PM</p>
                  <p>Saturday: 8:00 AM – 4:00 PM</p>
                  <p>Sunday: Closed</p>
                </div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#C4A962]/20 rounded-xl">
                    <i className="ri-phone-line text-[#C4A962] text-xl"></i>
                  </div>
                  <h3 className="font-bold text-white">Phone</h3>
                </div>
                <a href="tel:781-237-3166" className="text-[#C4A962] font-semibold hover:text-[#B39952] transition-colors">
                  781-237-3166
                </a>
              </div>
              <a
                href="https://www.google.com/maps?ll=42.310564,-71.276001&z=13&t=m&hl=en&gl=US&mapclient=embed&cid=14625480212699801249"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-[#C4A962] text-white px-6 py-3.5 rounded-xl font-semibold hover:bg-[#B39952] transition-colors whitespace-nowrap w-full"
              >
                <i className="ri-navigation-line"></i>
                Get Directions
              </a>
            </div>

            {/* Map */}
            <div className="lg:col-span-2 rounded-2xl overflow-hidden h-96 lg:h-auto min-h-80">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11801.994221273937!2d-71.2760006!3d42.310564!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e3815826935e15%3A0xcaf824c3ab79e6a1!2sCustom%20Clothiers!5e0!3m2!1sen!2sus!4v1711556553393!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Custom Clothiers Wellesley Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Local SEO Content */}
      <section className="py-20 bg-[#111111]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-white mb-6 text-center">
            Custom Tailoring Throughout Massachusetts &amp; New England
          </h2>
          <div className="space-y-5 text-gray-400 text-base leading-relaxed">
            <p>
              <strong className="text-white">Custom Clothiers</strong> has been serving clients in <strong className="text-white">Wellesley, MA</strong> and
              throughout <strong className="text-white">Massachusetts</strong> since 1970. Our master tailors specialize in bespoke
              suits, custom shirts, blazers, and expert alterations — all crafted with 30+ precision measurements
              to ensure a fit unlike anything available off the rack.
            </p>
            <p>
              Whether you are searching for <em className="text-gray-300">custom tailoring near me in Boston</em>, a bespoke suit tailor
              in Newton, or expert alterations in Cambridge, our team is ready to serve you. We operate a
              full-service showroom in Wellesley and provide <strong className="text-white">house and office call appointments</strong>
              throughout the state — making premium tailoring more accessible than ever before.
            </p>
            <p>
              Our service areas include <strong className="text-white">Wellesley, Newton, Boston, Cambridge, Brookline, Needham,
              Weston, Natick, Framingham, Worcester</strong>, and beyond. We regularly travel to clients
              across the North Shore, South Shore, MetroWest, and throughout Greater Boston. If you are in
              Massachusetts or New England and looking for a trusted bespoke tailor — you have found us.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-[#0F0F0F]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <p className="text-[#C4A962] font-semibold tracking-widest uppercase text-sm mb-3">
              Questions About Our Coverage
            </p>
            <h2 className="text-4xl font-bold text-white mb-4">
              Location &amp; Service Area FAQs
            </h2>
          </div>
          <div
            itemScope
            itemType="https://schema.org/FAQPage"
            className="space-y-4"
          >
            {faqs.map((faq, i) => (
              <div
                key={i}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                className="bg-white/5 rounded-xl border border-white/10 overflow-hidden hover:border-[#C4A962]/30 transition-all"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-white/5 transition-colors"
                >
                  <span itemProp="name" className="font-semibold text-white pr-4">{faq.q}</span>
                  <i className={`text-[#C4A962] text-xl flex-shrink-0 ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </button>
                {openIndex === i && (
                  <div
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                    className="px-6 pb-5"
                  >
                    <p itemProp="text" className="text-gray-400 leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-[#C4A962]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Serving Your Area — Starting Today
          </h2>
          <p className="text-white/85 text-xl mb-10 max-w-2xl mx-auto">
            Call for an appointment at our Wellesley showroom or schedule a house/office call
            anywhere in Massachusetts. Same great craftsmanship, on your terms.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-white text-[#C4A962] px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-100 transition-all transform hover:scale-105 whitespace-nowrap"
            >
              <i className="ri-calendar-line mr-2"></i>Book a Consultation
            </Link>
            <a
              href="tel:781-237-3166"
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-white/10 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>Call 781-237-3166
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default LocationsFAQSection;
